module.exports = __webpack_public_path__ + "img/google-logo.ac0894fc.svg";